import React from "react";

/**
 * Pagination component with smart page selection
 */
export const Pagination = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;

  const pages = [];
  const show = new Set(
    [1, totalPages, page, page - 1, page + 1].filter(
      (p) => p >= 1 && p <= totalPages
    )
  );
  const sorted = [...show].sort((a, b) => a - b);

  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) pages.push("...");
    pages.push(p);
  });

  return (
    <div className="pagination">
      <button
        className="btn-icon pag-btn pagination__arrow"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        ‹
      </button>

      {pages.map((p, i) =>
        p === "..." ? (
          <span
            key={`e${i}`}
            className="pagination__ellipsis"
          >
            …
          </span>
        ) : (
          <button
            key={p}
            onClick={() => onChange(p)}
            className={`btn-icon pag-btn pagination__page ${
              p === page ? "pagination__page--active" : ""
            }`}
          >
            {p}
          </button>
        )
      )}

      <button
        className="btn-icon pag-btn pagination__arrow"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
      >
        ›
      </button>

      <span className="pagination__summary">
        pág. {page} / {totalPages}
      </span>
    </div>
  );
};

export default Pagination;
